import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { USER_LEVEL_TYPE } from 'constants/common';
import { WalletIcon } from 'components/Atoms/Icon';

const Wallet = lazy(() => import('components/Pages/Wallet'));
const PaymentMethods = lazy(() =>
  import('components/Pages/Wallet/components/PaymentMethods')
);

export const walletRoutes = [
  {
    path: routePath.WALLET,
    component: Wallet,
    exact: true,
    name: routeName.WALLET,
    showMenu: true,
    icon: WalletIcon,
    roles: [USER_LEVEL_TYPE.ADMIN],
    condition: {
      accessWallet: true,
    },
    defaultShow: true,
  },
  {
    path: routePath.PAYMENT_METHOD,
    component: PaymentMethods,
    exact: true,
    name: routeName.PAYMENT_METHOD,
    roles: [USER_LEVEL_TYPE.ADMIN],
    condition: {
      accessWallet: true,
    },
  },
];
